/**
 * Error store - global error message management.
 */

import { create } from "zustand";

interface ErrorMessage {
  id: string;
  message: string;
  type: "error" | "warning" | "info";
  duration?: number;
  timestamp: number;
  title?: string;
  hideIcon?: boolean;
}

interface AddErrorOptions {
  title?: string;
  hideIcon?: boolean;
}

interface ErrorState {
  errors: ErrorMessage[];
  addError: (message: string, type?: "error" | "warning" | "info", duration?: number, opts?: AddErrorOptions) => void;
  removeError: (id: string) => void;
  clearErrors: () => void;
}

export const useErrorStore = create<ErrorState>((set) => ({
  errors: [],

  addError: (message, type = "error", duration, opts) => {
    set((s) => {
      // De-dupe: if an identical toast (same message/title/type) is already
      // queued, drop the new one rather than queue a duplicate.
      const isDuplicate = s.errors.some(
        (e) => e.message === message && e.title === opts?.title && e.type === type,
      );
      if (isDuplicate) return s;
      const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      return {
        errors: [...s.errors, { id, message, type, duration, timestamp: Date.now(), title: opts?.title, hideIcon: opts?.hideIcon }],
      };
    });
  },

  removeError: (id) => set((s) => ({ errors: s.errors.filter((e) => e.id !== id) })),
  clearErrors: () => set({ errors: [] }),
}));
